import { lazy } from "react";

export const FeedbackPage = lazy(() => import("../../Features/Feedback"));
